export enum GTagID {
  check_open_report = "check_open_report",
  view_network_outage = "view_network_outage",
  resolved_connection_performance = "resolved_connection_performance",
  connection_performance_livechat = "connection_performance_livechat",
  connection_failure_livechat = "connection_failure_livechat",
  resolved_connection_failure = "resolved_connection_failure",
  diagnose_loader = "diagnose_loader",
  no_outage_without_token = "no_outage_without_token",
  outage_without_token = "outage_without_token",
  create_report_troubleshoot = "create_report_troubleshoot",
  create_report_manual_troubleshoot = "create_report_manual_troubleshoot",
}
